export default "__VITE_ASSET__CsFmIoHq__"